var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "app-new-access-model",
      "modal-class": ['right', 'modal-resource'],
      "hide-footer": "",
      "hide-header": ""
    },
    on: {
      "show": _vm.updateIndexAccordingToStore
    }
  }, [_c('div', {
    class: _vm.$style.container,
    attrs: {
      "data-modal-app-new-access": ""
    }
  }, [_vm.appDescriptions.length > 1 ? _c('div', {
    class: _vm.$style.buttons
  }, [_c('div', {
    on: {
      "click": _vm.goToPrevious
    }
  }, [_c('MottoIcon', {
    staticClass: "cursor-pointer",
    class: _vm.$style.previousButton,
    attrs: {
      "name": "Arrow",
      "icon-color": "orange"
    }
  }), _c('p', [_vm._v("Previous")])], 1), _c('div', {
    on: {
      "click": _vm.goToNext
    }
  }, [_c('p', [_vm._v("Next")]), _c('MottoIcon', {
    staticClass: "cursor-pointer",
    class: _vm.$style.nextButton,
    attrs: {
      "name": "Arrow",
      "icon-color": "orange"
    }
  })], 1)]) : _c('div', {
    staticStyle: {
      "height": "40px"
    }
  }), _c('div', {
    class: _vm.$style.congratulationsContainer
  }, [_c('h2', [_vm._v("Congratulations " + _vm._s(_vm.currentUser.firstName) + "!")]), _c('p', [_vm._v("Your new "), _c('b', [_vm._v(_vm._s(_vm.selectedAppTitle))]), _vm._v(" access includes...")])]), _vm._l(_vm.selectedAppDescriptions, function (description) {
    return _c('div', {
      key: description.title
    }, [_c('h3', {
      class: _vm.$style.newGroupsHeader
    }, [_vm._v(_vm._s(description.groups))]), _c('div', {
      class: _vm.$style.descriptionsContainer
    }, [_c('span', [_c('b', {
      domProps: {
        "innerHTML": _vm._s(description.title + ' - ')
      }
    }), _vm._v(" " + _vm._s(description.description))])])]);
  }), _vm.selectedAppInfo ? _c('div', {
    class: _vm.$style.coursesContainer
  }, [_c('img', {
    class: _vm.$style.mottoLearnLogo,
    attrs: {
      "src": require("@assets/images/motto-learn-transparent.png"),
      "alt": ""
    }
  }), _c('p', {
    staticClass: "color-primary-blue font-weight-bold"
  }, [_c('a', {
    staticClass: "color-secondary-light-blue",
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "href": _vm.selectedAppInfo.mottoLearnUrl,
      "target": "_blank"
    }
  }, [_vm._v("> CLICK HERE")]), _vm._v(" for " + _vm._s(_vm.selectedAppTitle) + " courses tailored to your role(s). ")])]) : _vm._e(), _c('div', {
    class: _vm.$style.learnIcons
  }, [_c('div', [_c('MottoIcon', {
    attrs: {
      "name": "RocketColored"
    }
  }), _c('p', {
    staticClass: "color-secondary-light-blue cursor-pointer",
    staticStyle: {
      "text-decoration": "underline"
    },
    on: {
      "click": function click($event) {
        return _vm.launchApp(_vm.selectedAppInfo);
      }
    }
  }, [_vm._v("> Launch App")])], 1), _c('div', [_c('MottoIcon', {
    class: _vm.$style.big,
    attrs: {
      "name": "ComputerColored"
    }
  }), _c('p', {
    staticClass: "color-secondary-light-blue cursor-pointer",
    staticStyle: {
      "text-decoration": "underline"
    },
    on: {
      "click": _vm.redirectToMyTech
    }
  }, [_vm._v("> See all of my Motto Technology access")])], 1)])], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }